//packages
import React from 'react'
import ReactDOM from 'react-dom'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { Provider } from 'react-redux'

// Lazy load PayPal only when needed
const PayPalProvider = React.lazy(() =>
  import('./providers/PayPalProvider').then(module => ({ default: module.PayPalProvider }))
)

// Defer Google Analytics with optimized loading
const initAnalytics = () => {
  import('react-ga4').then((ReactGA) => {
    const TRACKING_ID = 'G-G6P9RF1KTS'
    ReactGA.default.initialize(TRACKING_ID)
    ReactGA.default.send({ hitType: 'pageview', page: window.location.pathname })
  })
}

// Initialize analytics with idle callback to prevent forced reflows
if (typeof window !== 'undefined') {
  loadAnalyticsWithIdleCallback(initAnalytics, 3000)
}

import router from 'app/route/Routes'
import store from 'app/reducers/rootReducer'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import { initializeAssetPreloading } from 'app/utils/cacheUtils'
import { initializeAnalyticsOptimizations, loadAnalyticsWithIdleCallback } from 'app/utils/analyticsUtils'

// Initialize asset preloading for better performance
initializeAssetPreloading()

// Initialize analytics optimizations to prevent forced reflows
initializeAnalyticsOptimizations()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <React.Suspense fallback={<div>Loading...</div>}>
        {/* <PayPalProvider> */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
        <RouterProvider router={router} />
        {/* </PayPalProvider> */}
      </React.Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
